export default {
  series: 1,
  data: 'Category;Series 1\nAfrica;10\nAmerica;8\nAsia;6\nEurope;4',
};
